export default "__VITE_ASSET__bf111411__"